import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { ProvidersServices } from '../../../providers/services';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'create-provider',
  templateUrl: 'create-provider.html',
})
export class CompCreateProviderPage {
  name: string = '';
  email: string = '';
  phone: string = '';
  origin: string;

  constructor(
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    private toastCtrl: ToastController,
    public navParams: NavParams,
    public analyticsServices: AnalyticsServices,
    public providersServices: ProvidersServices) {
    this.origin = this.navParams.get('origin');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  save() {
    //Comprovamos que tenga nombre y email o telefono
    if (this.name != '' && (this.email != '' || this.phone != '')) {
      //Creamos el proveedor y guardamos en bbdd
      this.insert();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  insert() {
    let _provider = {
      UID_RESTAURANT: this.globals.restaurant_uid,
      address: '',
      contact_name: '',
      email: this.email,
      fixed_phone: '',
      name: this.name,
      nif: '',
      no_provider: false,
      phone: this.phone,
      created_at: new Date(),
      updated_at: new Date(),
    };
    this.providersServices.afs.collection('providers').add(_provider).then(doc => {
      //Insertar proveedor al listado
      this.globals.GAtrackView('Providers', 'Providers - Create', this.globals.restaurant.email, 'Create/Update', 'Create provider', 'Providers', this.name);
      if (this.origin === 'ingredient') {
        this.insertToIngredient(_provider, doc.id);
      } else if (this.origin === 'product') {
        this.insertToProduct(_provider, doc.id);
      }
      this.globals.launchToast(this.translate.instant('general-proveedor') + ' ' + _provider.name + ' ' + this.translate.instant('instant-anadido-correctemente'), 3000, 'bottom');
      this.close();
    });
  }

  insertToIngredient(provider, provider_uid) {
    provider.UID = provider_uid;
    var _array = Array();
    _array.push(provider.UID);
    _array.push(provider.name);
    _array.push(provider.nif);
    _array.push(provider.address);
    _array.push(''); //province
    _array.push(''); //city
    _array.push(provider.phone);
    _array.push(''); //country
    _array.push(provider.email);
    _array.push(provider.contact_name);
    _array.push(false);//default
    _array.push(0);//price_notax
    _array.push(0);//tax
    _array.push(0);//price
    //Hacemos push al listado de proveedores seleccionados
    this.providersServices.providers_array_tmp.push(_array);
    this.providersServices.providers_array_tmp = [...this.providersServices.providers_array_tmp];
    //Hacemos push al listado de todos los proveedores
    this.providersServices.providers_array_filtered.push(provider);
    this.providersServices.providers_array_filtered = [...this.providersServices.providers_array_filtered];
  }

  insertToProduct(provider, provider_uid) {
    provider.UID = provider_uid;
    var _array = Array();
    _array.push(provider.UID);
    _array.push(provider.name);
    _array.push(provider.nif);
    _array.push(provider.address);
    _array.push(''); //province
    _array.push(''); //city
    _array.push(provider.phone);
    _array.push(''); //country
    _array.push(provider.email);
    _array.push(provider.contact_name);
    _array.push(false);//default
    _array.push(0);//price_notax
    _array.push(0);//tax
    _array.push(0);//price
    //Hacemos push al listado de proveedores seleccionados
    this.providersServices.providers_array_tmp.push(_array);
    this.providersServices.providers_array_tmp = [...this.providersServices.providers_array_tmp];
    //Hacemos push al listado de todos los proveedores
    this.providersServices.providers_array_filtered.push(provider);
    this.providersServices.providers_array_filtered = [...this.providersServices.providers_array_filtered];
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/popups/create-provider/create-provider.ts